import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import './lib'
import 'element-ui/lib/theme-chalk/index.css'
import './global.scss'

Vue.config.productionTip = false

window.oncontextmenu = function (e) {
  alert('禁止使用右键')
  e.preventDefault()
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
